
import { useCases } from "@/core";
import { formatDate } from "@/presentation/utils/dateHelpers";
import ListControllerMixin from "@/utils/ListControllerMixin";
import Vue from "vue";

export default Vue.extend({
  mixins: [ListControllerMixin],
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      filters: {
        page: 1,
        q: "",
      },
      columns: [
        { name: "Usuário", sortName: null, order: null },
        { name: "Plataforma", sortName: null, order: null },
        { name: "Motivo", sortName: null, order: null },
        { name: "Data e hora", sortName: null, order: null },
      ],
    };
  },
  methods: {
    fetchPromise() {
      return useCases.listCancellationReasons.execute({
        page: this.filters.page,
        q: this.filters.q,
      });
    },
    formatDate,
  },
});
